import React, { useState } from "react";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../../config/firebase";
import { Button } from "../../tailwind/components/Button";

interface Props {
  navigateTo?: string;
  onClick?: () => void;
}

const LogoutButton = ({ navigateTo = "/log-in", onClick }: Props) => {
  const [disabled, setDisabled] = useState(false);
  const navigate = useNavigate();
  const logout = () => {
    setDisabled(true);
    
    if (onClick) {
      onClick();
    }

    signOut(auth)
      .then(() => {
        navigate(navigateTo);
      })
      .catch((error) => {
        console.error(error);
        setDisabled(false);
      });
  };

  return (
    <Button className="cursor-pointer" disabled={disabled} onClick={logout}>
      Log Out
    </Button>
  );
};

export default LogoutButton;
